module.exports = __webpack_public_path__ + "static/media/merntasks.f97786e6.png";